import React, { useEffect } from "react";
import { Typography } from '@material-ui/core';
import FormScopeDefiner from "../../../../Component/Forms/FormScopeDefiner";
import ThemeControls from "../../../../Component/AllThemesControl";
import contextJson from './masterJson.json';
import fieldsData from './viewTableColumn.json';
 

function Create() {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const contextClasses = classes.topSpace;
  const contextObjective = "create";
  const apiContextObj = fieldsData.config;
  let sideImageData = {};

  
  useEffect(()=>{
    Object.keys(contextJson).forEach((key, index) => {
      if (key !== "xioFEConfig") {
        contextJson[key].fields.map((field) => {
          if (field.field_type === "custom") {
            field.field_value = "{}";
          } else if (field.field_default_value) {
            field.field_value = field.field_default_value
            field.id = ""
            field.field_helperText = ""
          } else {
            field.field_value = "";
            field.field_helperText = "";
            field.id = "";
          }
          return field; // <-- add this return statement
        });
  
        // =---sideIMage---dataAssing--->
        if (contextJson['xioFEConfig'] && contextJson['xioFEConfig'].sideImageData) {
          sideImageData = contextJson['xioFEConfig'].sideImageData;
        }
      }
    });
  },[])


  return (
    <div className={classes.main}>
      {/* <PolicyImg Image={smsPolicyImg} data={sideImageData}/>  */}
      <div className={classes.formAline}>
        {/* <Typography variant="h6" className={classes.marginChange}>
          {contextHeading}
        </Typography> */}
        <FormScopeDefiner value={{ contextJson, apiContextObj,   contextClasses, contextObjective }}>
        </FormScopeDefiner>
      </div>
    </div>
  )
}

export default Create;
